import React from 'react';

export const recipeDefaults = (item: any) => {
  const units = item?.recipeUnits || [];
  const preferred = units.find((u: any) => u.id === 'g') || units.find((u: any) => u.id === 'mL');
  return { quantity: preferred ? '' : 1, unit: preferred?.id };
};

export default function RecipeAmount({ entry, item, label, onChange }: {
  entry: any; item: any; label: string; onChange: (patch: any) => void;
}) {
  const units = item?.recipeUnits || [{ id: item?.unit || '', label: item?.unit || 'unidad de inventario', factor: 1, minimum: 0.0001 }];
  const stock = units.find((u: any) => u.factor === 1) || units[0];
  const selected = units.find((u: any) => u.id === entry.unit) || stock;
  const equivalent = entry.quantity === '' ? NaN : Number(entry.quantity) * selected.factor;
  const rounded = Math.round(equivalent * 1e6) / 1e6;
  const valid = Number.isFinite(equivalent) && equivalent > 0 && (entry.unit === undefined
    ? equivalent >= 0.0001
    : rounded >= 0.0001 && rounded <= 1e9 && Math.abs(rounded - equivalent) <= Math.max(1e-12, Math.abs(equivalent) * Number.EPSILON * 4));
  return <div className="w-full min-w-0 space-y-2">
    <div className="grid grid-cols-2 gap-2">
      <label className="min-w-0 text-xs">Cantidad por un producto
        <input aria-label={label} type="number" required min={selected.minimum} step="any"
          className="w-full min-h-[44px] rounded-xl bg-white dark:bg-slate-800 px-3"
          value={entry.quantity ?? ''} onChange={e => onChange({ quantity: e.target.value === '' ? '' : Number(e.target.value) })}
          ref={node => node?.setCustomValidity(valid ? '' : 'Introduce una cantidad positiva: mínimo 0.0001 en inventario y máximo 6 decimales.')} />
      </label>
      <label className="min-w-0 text-xs">Unidad de la receta
        <select aria-label={'Unidad para ' + label} className="w-full min-h-[44px] rounded-xl bg-white dark:bg-slate-800 px-2"
          value={selected.id} onChange={e => {
            const next = units.find((u: any) => u.id === e.target.value);
            onChange({ unit: next.id, quantity: entry.quantity === '' ? '' : Number((Number(entry.quantity) * selected.factor / next.factor).toPrecision(15)) });
          }}>
          {units.map((u: any) => <option key={u.id} value={u.id}>{u.label}</option>)}
        </select>
      </label>
    </div>
    <p className="text-xs" aria-live="polite">{valid ? `Descuenta ${Number(equivalent.toPrecision(15))} ${item?.unit || ''} por un producto.` : 'Introduce la cantidad. Mínimo: 0.0001 en inventario; máximo 6 decimales.'}</p>
    {units.length === 1 && <p className="text-xs text-slate-500">Solo la misma unidad. Otras medidas requieren definir peso, contenido o densidad del insumo.</p>}
  </div>;
}
